import { render } from "./IconExcel.vue?vue&type=template&id=04427598"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconExcel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04427598"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04427598', __exports__)) {
    api.reload('04427598', __exports__)
  }
  
  module.hot.accept("./IconExcel.vue?vue&type=template&id=04427598", () => {
    api.rerender('04427598', render)
  })

}


export default __exports__